// OPX Motion — native scrolling; scroll-lock failsafe; GSAP scrub layers (Horizon .page-wrapper scroller aware)
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.body.style.overflow='';
  document.documentElement.style.overflow='';
  // FAILSAFE: never leave the INNER scroller locked without an open dialog/portal.
  // Horizon scrolls .page-wrapper (body overflow:hidden is native) — so guard the wrapper, not the body.
  setInterval(function(){
    var pw=document.querySelector('.page-wrapper');
    var open=document.querySelector('dialog[open], .opxgw-portal.is-open, [class*=drawer][open], details[open] > [class*=menu]');
    if(open)return;
    if(pw){
      var o=getComputedStyle(pw).overflowY;
      if(o==='hidden'){pw.style.overflowY='auto';}
      if(pw.style.overflow==='hidden')pw.style.overflow='';
    }else{
      if(getComputedStyle(document.body).overflow==='hidden'){document.body.style.overflow='';document.documentElement.style.overflow='';}
    }
  },1500);
  function boot(){
    if(!(window.gsap&&window.ScrollTrigger)){setTimeout(boot,150);return}
    gsap.registerPlugin(ScrollTrigger);
    if(reduce)return;
    var pw=document.querySelector('.page-wrapper');
    if(pw&&pw.scrollHeight>pw.clientHeight+40){ScrollTrigger.defaults({scroller:pw});}
    document.querySelectorAll('[data-opx-speed]').forEach(function(el){
      var sp=parseFloat(el.getAttribute('data-opx-speed'))||0.2;
      gsap.to(el,{yPercent:sp*-100,ease:'none',scrollTrigger:{trigger:el.closest('section')||el,start:'top bottom',end:'bottom top',scrub:true}});
    });
    document.querySelectorAll('[data-opx-kinetic]').forEach(function(stage){
      stage.querySelectorAll('.opxk-word').forEach(function(w,i){
        var dir=(i%2?1:-1),dist=(18+i*10)*dir;
        gsap.fromTo(w,{xPercent:dist},{xPercent:-dist,ease:'none',scrollTrigger:{trigger:stage,start:'top bottom',end:'bottom top',scrub:true}});
      });
      var media=stage.querySelector('.opxk-media');
      if(media){gsap.fromTo(media,{scale:1.15,yPercent:8},{scale:1,yPercent:-8,ease:'none',scrollTrigger:{trigger:stage,start:'top bottom',end:'bottom top',scrub:true}})}
    });
    document.querySelectorAll('[data-opx-fill]').forEach(function(el){
      var fc=el.getAttribute('data-opx-fill-color')||'#FFFFFF';
      var bc=el.getAttribute('data-opx-fill-base')||'#343B54';
      el.style.backgroundImage='linear-gradient(90deg,'+fc+' 0%,'+fc+' 50%,'+bc+' 50%,'+bc+' 100%)';
      el.style.backgroundSize='200% 100%';
      el.style.backgroundPosition='100% 0';
      el.style.webkitBackgroundClip='text';
      el.style.backgroundClip='text';
      el.style.webkitTextFillColor='transparent';
      gsap.to(el,{backgroundPosition:'0% 0',ease:'none',scrollTrigger:{trigger:el,start:'top 82%',end:'bottom 40%',scrub:true}});
    });
  }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();
